module.exports = __webpack_public_path__ + "static/media/kids_12.d9c7dc1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_12.jpg
// module id = 5868
// module chunks = 0